import styled from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { medium as mediumFontWeight } from "core/fontStyles";
import { H2 } from "core/Typography";

// styled-components
export const OpeningTextStyled = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
`;
export const H2Styled = styled(H2)`
    margin-bottom: ${convertPxToRem({ px: 4 })};
    color: ${colors.primary.diamond};
    ${mediumFontWeight};
`;
